export default __webpack_public_path__ + "static/media/Anjelica_img.5288f590.jpg";